
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user_guide",
      function () {
        return require("private-next-pages/user_guide/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user_guide"])
      });
    }
  